import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoading } from './shared/components/global-loading/global-loading';
import { NotificationCenter } from './shared/components/notification-center/notification-center';

@Component({
  selector: 'app-root',
  imports: [GlobalLoading, NotificationCenter, RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
